import { render } from "./dateFilter.vue?vue&type=template&id=365f11ca&scoped=true"
import script from "./dateFilter.vue?vue&type=script&lang=js"
export * from "./dateFilter.vue?vue&type=script&lang=js"

import "./dateFilter.vue?vue&type=style&index=0&id=365f11ca&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src384613071/src/admin-ui-svc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365f11ca"]])

export default __exports__